import React from "react";
import "../styles/StatCardFive.css";

const StatCardFive = () => {
  return (
    <div className="stat-card-five">
      <img src="/eclipse.svg" alt="background ellipse" className="ellipse" />
      <img src="/Roll-icon.svg" alt="roll icon" className="roll-icon" />
      <p className="stat-text">
        Achieve swift <br />
        Dispatch and Boost <br />
        Productivity
      </p>
    </div>
  );
};

export default StatCardFive;
